import { render, staticRenderFns } from "./MarkerAttractionContent.vue?vue&type=template&id=595fb89e&scoped=true"
import script from "./MarkerAttractionContent.vue?vue&type=script&lang=js"
export * from "./MarkerAttractionContent.vue?vue&type=script&lang=js"
import style0 from "./MarkerAttractionContent.vue?vue&type=style&index=0&id=595fb89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595fb89e",
  null
  
)

export default component.exports